import { render, staticRenderFns } from "./CopyBannerModal.vue?vue&type=template&id=9d8ae8e2&"
import script from "./CopyBannerModal.vue?vue&type=script&lang=js&"
export * from "./CopyBannerModal.vue?vue&type=script&lang=js&"
import style0 from "./CopyBannerModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports